module.exports = __webpack_public_path__ + "media/images/on-arrival-5d339c90e4823c040450dd9753165bc5.png";